export const headers = [
  { id: 'checkbox' },
  { id: 'hasAlert' },
  { id: 'order', label: 'Pedido' },
  { id: 'status', label: 'Estado' },
  { id: 'creationDate', label: 'Fecha de creación' },
  { id: 'lastUpdate', label: 'Ult. actualización' },
  { id: 'sender', label: 'Remitente' },
  { id: 'recipient', label: 'Destinatario' },
  { id: 'origin', label: 'Origen' },
  { id: 'destination', label: 'Destino' },
  { id: 'carrier', label: 'Transportista' },
  { id: 'products', label: 'Productos' },
  { id: 'tracking', label: 'Seguimiento' },
  { id: 'pickupDate', label: 'Recogida' },
]
